module.exports = __webpack_public_path__ + "img/logincar.4bb8a79f.svg";